import React, {Fragment} from "react";
import StepQuestion from "../../../../components/Step/StepQuestion";
import {RegistrationElements} from "../../../../domain/Registerv2/RegistrationElements";
import ContactDetails from "./ContactDetails";
import StepButton from "../../../../components/Step/StepButton";

export default class StopStep extends React.Component{

    render() {
        let message = this.props.stopMessage;

        return <Fragment>
            <StepQuestion>
                Hi {this.props[RegistrationElements.FIRST_NAME]},
                <br/><br/>
                {message}
                <br/><br/>
                <StepButton
                    color={"secondary"}
                    onClick={this.props.onBackClick}
                >
                    Back
                </StepButton>

                <ContactDetails
                    emailAddress={this.props.emailAddress}
                />
            </StepQuestion>
        </Fragment>
    }
}